import { useState } from "react";
import PayrollCompanyLayout from "../../../components/layouts/PayrollCompanyLayout";
import { Helmet } from "react-helmet-async";
import CustomTab from "../../../components/custom_tab/CustomTab";
import { BenefitsnAllowancesTabColumns } from "../../../components/custom_tab/tabColumns";
import { useSearchParams } from "react-router-dom";
import BenefitsView from "./views/BenefitsView";
import AllowancesView from "./views/AllowancesView";
import LoanBenefitsView from "./views/LoanBenefitsView";
import {
	PERMISSIONS,
	useValidateUserPermissions,
} from "../../../helpers/usePermissionManager";

const BenefitsAndAllowances = () => {
	const hasPermission = useValidateUserPermissions(
		[PERMISSIONS.COMPANY_CONFIGS_WRITE, PERMISSIONS.COMPANY_CONFIGS_READ],
		"OR",
	);
	const [searchParams] = useSearchParams();
	const [view, setView] = useState(searchParams.get("view") || "allowances");

	return (
		<>
			{hasPermission && (
				<PayrollCompanyLayout>
					<Helmet>
						<title>Benefits & Allowances | Company Flow</title>
					</Helmet>
					<h1 className="font-bold text-xl mb-8">Benefits & Allowances</h1>
					<CustomTab
						view={view}
						setView={setView}
						tabColumns={BenefitsnAllowancesTabColumns}
					>
						{view === "allowances" && <AllowancesView />}
						{view === "benefits" && <BenefitsView />}
						{view === "loanBenefits" && <LoanBenefitsView />}
					</CustomTab>
				</PayrollCompanyLayout>
			)}
		</>
	);
};

export default BenefitsAndAllowances;
